import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icons } from '../../elements/icon/resolver';
import { STEP_FINAL, STEP_OFFER } from '../../../utils/orderCompleteUpsell';

const CartIcon = Icons.checkoutCart;
const PaidIcon = Icons.checkoutPaid;
const GiftIcon = Icons.checkoutGift;
const ConfirmedIcon = Icons.checkoutConfirmed;

const ProgressStepper = ({ currentStep = STEP_OFFER }) => {
  const { t } = useTranslation();
  const steps = [
    { key: 'cart', labelKey: 'OrderComplete_Step_Cart', state: 'complete', Icon: CartIcon },
    { key: 'paid', labelKey: 'OrderComplete_Step_Paid', state: 'complete', Icon: PaidIcon },
    { key: 'offer', labelKey: 'OrderComplete_Step_Offer', state: currentStep === STEP_OFFER ? 'current' : 'complete', Icon: GiftIcon },
    { key: 'confirmed', labelKey: 'OrderComplete_Step_Confirmed', state: currentStep === STEP_FINAL ? 'current' : 'pending', Icon: ConfirmedIcon },
  ];

  return (
    <div className="t-flex t-items-start t-gap-2 t-py-0.5" aria-label="Checkout progress">
      {steps.map((step, index) => (
        <React.Fragment key={step.key}>
          <div className="t-flex t-w-10 t-flex-col t-items-center t-gap-1">
            <div
              className={`t-flex t-items-center t-justify-center ${
                step.state === 'pending'
                  ? 't-h-6 t-w-6 t-rounded-full t-bg-gray-200 t-p-1 t-text-gray-500'
                  : step.state === 'current'
                    ? 't-h-[26px] t-w-[26px] t-rounded-full t-bg-navy t-p-1 t-text-white'
                    : 't-h-5 t-w-5 t-text-navy'
              }`}
            >
              <step.Icon className="t-h-[18px] t-w-[18px]" />
            </div>
            <span className="t-text-center t-text-[9px] t-font-bold t-uppercase t-leading-tight t-text-gray-500">
              {t(step.labelKey)}
            </span>
          </div>
          {index < steps.length - 1 && (
            <div
              className={`t-mt-2.5 t-h-[1.5px] t-flex-1 ${
                steps[index + 1].state === 'pending' ? 't-bg-gray-200' : 't-bg-secondary'
              }`}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default ProgressStepper;
